// import { useEffect, useState } from "react";
// import { useLocation } from "react-router-dom";
// import "./single.scss";
// import Sidebar from "../../components/sidebar/Sidebar";
// import Navbar from "../../components/navbar/Navbar";
// import { Link } from "react-router-dom";
// import { serverUrl } from "../../temp";
// const ClassSingle = () => {
//   // Extracting classId using regular expressions
//   const location = useLocation();
//   // const classId = location.pathname.match(/\/class\/(\d+)/);
//   const classId = location.pathname.match(/\/class\/(\d+)/)?.[1];

//   const [classe, setClasse] = useState(null);
//   let [token] = useState(localStorage.getItem("token"));

//   const redirectToLogin = () => {
//     alert("Plaese Login first then you can access this page...");
//     window.location.href = "/"; // Replace "/login" with the actual login page path
//   };

//   const fetchClass = async () => {
//     try {
//       const response = await fetch(`${serverUrl}/class/${classId}`);
//       // if (!response.ok) {
//       //     throw new Error('Failed to fetch class');
//       // }
//       const data = await response.json();
//       setClasse(data);
//       localStorage.setItem("classData", JSON.stringify(data));
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   useEffect(() => {
//     if (classId) {
//       fetchClass();
//     }
//   }, [classId]);

//   return (
//     <>
//       {!token && redirectToLogin()}
//       {token && (
//         <div className="single">
//           <Sidebar />
//           <div className="singleContainer">
//             <Navbar />
//             <div className="top">
//               <div className="left">
//                 <h1 className="title">Class Information</h1>
//                 <div className="details">
//                   <h1 className="itemTitle">{classe?.data.name}</h1>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Id: </span>
//                     <span className="itemValue">{classe?.data.id}</span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Center Id: </span>
//                                             <span className="itemValue">{classe?.data.center_id}</span>
//                                         </div> */}
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Name: </span>
//                     <span className="itemValue">{classe?.data.name}</span>
//                   </div> */}
//                   <div className="detailItem">
//                     <span className="itemKey">Total Student: </span>
//                     <span className="itemValue">
//                       {classe?.data.total_students}
//                     </span>
//                   </div>
//                   {/* <div className="detailItem">
//                     <span className="itemKey">Subjects: </span>
//                     <span className="itemValue">
//                       {classe?.data.subject_names}
//                     </span>
//                   </div> */}
//                   {/* <div className="detailItem">
//                                             <span className="itemKey">Status: </span>
//                                             <span className="itemValue">{classe?.data.status}</span>
//                                         </div> */}
//                 </div>
//               </div>
//             </div>
//             {/* <div className="right">
//                     <Chart aspect={3 / 1} title="class Spending ( Last 6 Months)" />
//                 </div> */}
//           </div>
//           {/* <div className="bottom">
//                 <h1 className="title">Last Transactions</h1>
//                 <List />
//                 </div> */}
//         </div>
//       )}
//     </>
//   );
// };

// export default ClassSingle;
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { serverUrl } from "../../temp";

const ClassSingle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const classId = location.pathname.match(/\/class\/(\d+)/)?.[1];
  const [classe, setClasse] = useState(null);
  const [token] = useState(localStorage.getItem("token"));
  const [isLoading, setIsLoading] = useState(true);

  const redirectToLogin = () => {
    alert("Please login first to access this page...");
    window.location.href = "/";
  };

  const fetchClass = async () => {
    try {
      const response = await fetch(`${serverUrl}/class/${classId}`);
      const data = await response.json();
      setClasse(data);
      localStorage.setItem("classData", JSON.stringify(data));
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (classId) {
      fetchClass();
    }
  }, [classId]);

  if (!token) {
    redirectToLogin();
    return null;
  }

  return (
    <div className="single">
      <Sidebar />
      <div className="singleContainer">
        <Navbar />
        <div className="top">
          <div className="left">
            <div className="flex justify-between items-center mb-4">
              <button
                onClick={() => navigate(-1)}
                className="px-3 py-1 text-sm bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-all border border-purple-200 flex items-center gap-1 shadow-sm hover:shadow-md"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-4 w-4"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                Back
              </button>
              <h1 className="title flex-1 text-center">Class Information</h1>
              <div className="w-20"></div>
            </div>

            {isLoading ? (
              <div className="flex justify-center items-center h-64">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
              </div>
            ) : (
              <div className="space-y-6">
                {/* Class Header */}
                <div className="bg-white rounded-xl p-6 shadow-sm">
                  <div className="flex flex-col md:flex-row gap-6 items-center md:items-start">
                    {/* Class Icon */}
                    <div className="flex-shrink-0">
                      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-purple-100 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-10 w-10 text-purple-600"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 14l9-5-9-5-9 5 9 5z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 14l9-5-9-5-9 5 9 5z"
                          />
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 14v6l-9-5m9 5l9-5m-9 5v-6"
                          />
                        </svg>
                      </div>
                    </div>

                    {/* Class Info */}
                    <div className="flex-1 text-center md:text-left">
                      <h1 className="text-2xl font-bold text-gray-800 mb-3">
                        {classe?.data.name}
                      </h1>

                      <div className="grid grid-cols-1 gap-4">
                        {classe?.data.total_students && (
                          <div className="bg-gray-50 rounded-lg p-4">
                            <span className="text-gray-500 block text-sm mb-1">
                              Total Students:
                            </span>
                            <span className="font-medium text-lg text-purple-600">
                              {classe.data.total_students}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassSingle;
